export default {"src":"/_next/static/media/DocumentCheck.22a0748e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};